import React from 'react';
import Tablename from "./FieldTable/Tablename.js";
import FieldTableData from "./FieldTable/FieldTableData.js";
import ActionButtons from "./TableActions/ActionButtons.js";
import TableMetaData from "./TableActions/TableMetaData.js";
import ForeignKeys from "./TableActions/ForeignKeys.js";
import UniqueKeys from "./TableActions/UniqueKeys.js";
import Indices from "./TableActions/Indices.js";

const Inputcontainer = () => {
  return (
    <div className="input-container">
      <Tablename />
      <FieldTableData />
      <ActionButtons />
      <TableMetaData />
      <Indices />
      <ForeignKeys />
      <UniqueKeys />
    </div>
  );
};

export default Inputcontainer;